import { useState } from 'react';

import { Spin } from 'antd';

import PhotographerForm from './photographer-form';

import TitledCard from '../../../layout-components/titled-card';

const NewPhotographer: React.FC = () => {
  const [loading, setLoading] = useState(false);

  return (
    <Spin spinning={loading}>
      <TitledCard title="Nowa biografia fotografa" backUrl="..">
        <PhotographerForm setLoading={setLoading} />
      </TitledCard>
    </Spin>
  );
};
export default NewPhotographer;
